<script setup>
import AppIcon from 'module/icon/AppIcon.vue';
import { reactive } from 'vue';
import { useBreakpoints } from '../../composables/breakpoints';

const expanded = reactive({
    about: false,
    forEmployers: false,
    partnersAndPortals: false,
    myProfile: false,
});

const { isMobile } = useBreakpoints();
function toggleAccordion(section) {
    if (!isMobile.value) return;

    expanded[section] = !expanded[section];
}
</script>

<template>
    <div class="m-footer__row">
        <div
            class="m-footer__container"
            :class="expanded.about && 'm-footer__container--open'"
            @click="toggleAccordion('about')"
        >
            <h3 class="m-footer__groupHeader">
                Über karriere.at
                <div class="m-footer__groupHeaderIcon">
                    <AppIcon
                        name="arrow-down"
                        size="small"
                    />
                </div>
            </h3>
            <ul class="m-footer__list m-footer__list--noBorder">
                <li class="m-footer__item">
                    <a
                        class="m-footer__link"
                        href="/ueber-uns"
                    >Über uns</a>
                </li>
                <li class="m-footer__item">
                    <a
                        class="m-footer__link"
                        href="/ueber-uns/jobs-bei-karriere-at"
                    >Jobs bei karriere.at</a>
                </li>
                <li class="m-footer__item">
                    <a
                        class="m-footer__link"
                        href="/presse"
                    >Presse</a>
                </li>
            </ul>

            <ul class="m-footer__list">
                <li class="m-footer__item">
                    <a
                        class="m-footer__link"
                        href="/mobileapp"
                    >Mobile App</a>
                </li>
                <li class="m-footer__item">
                    <a
                        class="m-footer__link"
                        href="https://www.karriere.at/blog/"
                    >Blog & Tipps</a>
                </li>
            </ul>
        </div>

        <div
            class="m-footer__container"
            :class="expanded.forEmployers && 'm-footer__container--open'"
            @click="toggleAccordion('forEmployers')"
        >
            <h3 class="m-footer__groupHeader">
                Für Arbeitgeber
                <div class="m-footer__groupHeaderIcon">
                    <AppIcon
                        name="arrow-down"
                        size="small"
                    />
                </div>
            </h3>
            <ul class="m-footer__list">
                <li class="m-footer__item">
                    <a
                        class="m-footer__link"
                        href="https://business.karriere.at/"
                    >
                        Produkte & Preise
                    </a>
                </li>
                <li class="m-footer__item">
                    <a
                        class="m-footer__link"
                        href="https://business.karriere.at/produkte/stelleninserate"
                    >
                        Inserat schalten
                    </a>
                </li>
                <li class="m-footer__item">
                    <a
                        class="m-footer__link"
                        href="https://business.karriere.at/produkte/talentsuche"
                    >
                        Talentsuche
                    </a>
                </li>
                <li class="m-footer__item">
                    <a
                        class="m-footer__link"
                        href="https://business.karriere.at/produkte/arbeitgeberprofil"
                    >
                        Employer Branding
                    </a>
                </li>
            </ul>
        </div>

        <div
            class="m-footer__container"
            :class="expanded.partnersAndPortals && 'm-footer__container--open'"
            @click="toggleAccordion('partnersAndPortals')"
        >
            <h3 class="m-footer__groupHeader">
                Partner und Portale
                <div class="m-footer__groupHeaderIcon">
                    <AppIcon
                        name="arrow-down"
                        size="small"
                    />
                </div>
            </h3>
            <ul class="m-footer__list">
                <li class="m-footer__item">
                    <a
                        class="m-footer__link"
                        href="https://jobradius.at"
                    >Jobradius</a>
                </li>
                <li class="m-footer__item">
                    <a
                        class="m-footer__link"
                        href="https://www.itstellen.at/"
                    >itstellen.at</a>
                </li>
                <li class="m-footer__item">
                    <a
                        class="m-footer__link"
                        href="https://www.techtalents.at/"
                    >techtalents.at</a>
                </li>
                <li class="m-footer__item">
                    <a
                        class="m-footer__link"
                        href="https://www.financejobs.at/"
                    >financejobs.at</a>
                </li>
                <li class="m-footer__item">
                    <a
                        class="m-footer__link"
                        href="https://www.salescareer.at/"
                    >salescareer.at</a>
                </li>
                <li class="m-footer__item">
                    <a
                        class="m-footer__link"
                        href="https://www.jobs.at/"
                    >jobs.at</a>
                </li>
                <li class="m-footer__item">
                    <a
                        class="m-footer__link"
                        href="https://hokify.at/"
                    >hokify</a>
                </li>
                <li class="m-footer__item">
                    <a
                        class="m-footer__link"
                        href="https://www.erecruiter.net/"
                    >eRecruiter</a>
                </li>
            </ul>
        </div>

        <div
            class="m-footer__container"
            :class="expanded.myProfile && 'm-footer__container--open'"
            @click="toggleAccordion('myProfile')"
        >
            <h3 class="m-footer__groupHeader">
                Mein Profil
                <div class="m-footer__groupHeaderIcon">
                    <AppIcon
                        name="arrow-down"
                        size="small"
                    />
                </div>
            </h3>
            <ul class="m-footer__list">
                <li class="m-footer__item">
                    <a
                        class="m-footer__link"
                        href="/profil/lebenslauf"
                    >Lebenslauf</a>
                </li>
                <li class="m-footer__item">
                    <a
                        class="m-footer__link"
                        href="/jobalarm"
                    >Job-Alarm</a>
                </li>
                <li class="m-footer__item">
                    <a
                        class="m-footer__link"
                        href="/watchlist"
                    >Merkliste</a>
                </li>
                <li class="m-footer__item">
                    <a
                        class="m-footer__link"
                        href="/companyalarm"
                    >Firmen-Alarm</a>
                </li>
                <li class="m-footer__item">
                    <a
                        class="m-footer__link"
                        href="/matching"
                    >Job-Empfehlungen</a>
                </li>
            </ul>
        </div>
    </div>
</template>
